import React from "react";

export function SectionTitle({ over, title, sub }) {
  return (
    <div className="text-center max-w-3xl mx-auto">
      <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">{over}</p>
      <h2 className="font-display text-3xl md:text-4xl gold-gradient-text">{title}</h2>
      <div className="gold-divider my-5 mx-auto max-w-[220px]" />
      {sub && <p className="text-gold-soft/95">{sub}</p>}
    </div>
  );
}

export function DecorParticles() {
  const dots = Array.from({ length: 14 });
  return (
    <div className="absolute inset-0 pointer-events-none">
      {dots.map((_, i) => (
        <span
          key={`particle-${i}`}
          className="absolute float-slow"
          style={{
            top: `${(i * 37) % 100}%`,
            left: `${(i * 53) % 100}%`,
            width: 4, height: 4, borderRadius: 999,
            background: "radial-gradient(circle, #f7e7a3 0%, transparent 70%)",
            animationDelay: `${i * 0.4}s`
          }}
        />
      ))}
    </div>
  );
}

export function WhatsAppIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="shrink-0" aria-hidden="true">
      <path d="M20.52 3.48A11.94 11.94 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.83c0 2.08.55 4.11 1.6 5.9L0 24l6.44-1.69a11.83 11.83 0 0 0 5.6 1.42h.01c6.53 0 11.83-5.3 11.83-11.83 0-3.16-1.23-6.13-3.36-8.42zM12.05 21.3a9.47 9.47 0 0 1-4.83-1.32l-.35-.21-3.82 1 .02-3.72-.23-.38a9.5 9.5 0 1 1 17.68-4.83c0 5.23-4.26 9.46-8.46 9.46z"/>
    </svg>
  );
}
